import SkillNode from "../skillTree/SkillNode";
import SkillTreeGraph from "../skillTree/SkillTreeGraph";
import SkillType from "../skillTree/SkillType";
import BigNumSave from "./BigNumSave";

export default class SkillTreeSave {
    constructor() {
    }

    /**
     * @param {SkillTreeGraph} skillTree
     * @returns {Object}
     */
    static generateSave(skillTree) {
        const saveState = {};

        // Let's not save the center offset or the zoom. It's fine if that is reset each time.

        saveState.skills = [];
        for (let i = 0; i < skillTree.skills.length; i++) {
            saveState.skills.push(this.generateSkillSave(skillTree.skills[i]));
        }

        return saveState;
    }

    /**
     * @param {SkillTreeGraph} skillTree
     * @param {Object} saveState 
     */
    static loadSave(skillTree, saveState) {
        if (!saveState) {
            console.log('SkillTreeSave.loadSave() No save state. Not loading skills!');
            return;
        }

        const skillStates = saveState.skills;
        if (!skillStates || skillStates.length === 0) {
            console.log('SkillTreeSave.loadSave() No skill save data found');
            return;
        }

        for (let i = 0; i < skillStates.length; i++) { 
            try {
                this.loadSkillSave(skillTree, skillStates[i]);
            }
            catch (error) {
                console.error('SkillTreeSave.loadSave() Failed to load skill.', error.message);
            }
        }
    }

    /**
     * @private
     * @param {SkillType} skill 
     * @returns {Object}
     */
    static generateSkillSave(skill) {
        const saveState = {};

        saveState.id = skill.id;
        saveState.points = BigNumSave.save(skill.pointsSpent);
        saveState.unlocked = skill.unlocked;

        saveState.nodes = [];
        for (let i = 0; i < skill.nodes.length; i++) {
            saveState.nodes.push(this.generateSkillNodeSave(skill.nodes[i]));
        }

        return saveState;
    }

    /**
     * @private
     * @param {SkillTreeGraph} skillTree 
     * @param {Object} skillState 
     */
    static loadSkillSave(skillTree, skillState) {
        if (!skillState) {
            return;
        }


        const id = skillState.id;
        if (!id) {
            console.log('SkillTreeSave.loadSkillSave() No id found for skill.');
            return;
        }

        const skill = skillTree.findSkillById(id);
        if (!skill) {
            console.log('SkillTreeSave.loadSkillSave() Failed to find skill for id=' + id);
            return;
        }

        BigNumSave.load(skillState.points, skill.pointsSpent);

        skill.unlocked = skillState.unlocked;

        const nodesSave = skillState.nodes;
        if (!nodesSave || nodesSave.length === 0) {
            console.log('SkillTreeSave.loadSkillSave() No skill nodes saved for skill id=' + id);
            return;
        }

        for (let i = 0; i < nodesSave.length; i++) {
            this.loadSkillNodeSave(skill, nodesSave[i]);
        }

        skill.onSaveLoad();
    }

    /**
     * @private
     * @param {SkillNode} skillNode 
     * @returns {Object}
     */
    static generateSkillNodeSave(skillNode) {
        const saveState = {};

        saveState.id = skillNode.id;
        saveState.purchased = skillNode.purchased;

        return saveState;
    }

    /**
     * @private
     * @param {SkillType} skill 
     * @param {Object} nodeSave 
     */
    static loadSkillNodeSave(skill, nodeSave) {
        if (!nodeSave) {
            console.log('SkillTreeSave.loadSkillNodeSave() No node save state.');
            return;
        }

        const id = nodeSave.id;
        if (!id) {
            console.log('SkillTreeSave.loadSkillNodeSave() No id found for skill node.');
            return;
        }

        const skillNode = skill.getSkillNodeById(id);
        if (!skillNode) {
            console.log('SkillTreeSave.loadSkillNodeSave() No skill node found for id=' + id);
            return;
        }

        if (nodeSave.purchased) {
            try {
                skillNode.onPurchaseFromSave();
            }
            catch (error) {
                console.error('SaveTreeSave.loadSkillNodeSave() Failed to load skill node: ' + id, error.message);
                throw error;
            }
        }
    }

}